import React from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import {
  FOOTAGE_AI_STYLES,
  FOOTAGE_PEOPLE,
  type FootageAiStyle,
  type FootagePeople,
} from 'fym-shared/src/music24/musicVideoApi';
import { TypedMemo } from '../../../common/types';
import { aiPeopleMessages, aiStyleMessages, footageMessages } from '../../messages/footageMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the editor; each part uses its own slice of it */
import styles from '../../MusicVideoEditor.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface AiLookControlsProps {
  style: FootageAiStyle;
  onStyle: (style: FootageAiStyle) => void;
  people: FootagePeople;
  onPeople: (people: FootagePeople) => void;
  /** True while a style text sets the look: the style chips are off (the API drops the look line). */
  styleChipsOff: boolean;
}

/** The style chips and the people choice of an AI clip (design music-video h1). */
const AiLookControlsComponent: React.FC<AiLookControlsProps> = ({
  style,
  onStyle,
  people,
  onPeople,
  styleChipsOff,
}) => {
  const intl = useIntl();
  return (
    <>
      <div className={styles.chips}>
        {FOOTAGE_AI_STYLES.map((item) => (
          <button
            key={item}
            type="button"
            className={clsx(styles.chip, item === style && !styleChipsOff && styles.chipOn)}
            aria-pressed={item === style && !styleChipsOff}
            disabled={styleChipsOff}
            onClick={() => onStyle(item)}
          >
            {intl.formatMessage(aiStyleMessages[item])}
          </button>
        ))}
      </div>
      <div className={styles.inspectorGrid}>
        <span className={styles.rowLabel}>{intl.formatMessage(footageMessages.aiPeople)}</span>
        <div className={styles.segmented}>
          {FOOTAGE_PEOPLE.map((item) => (
            <button
              key={item}
              type="button"
              className={clsx(styles.segment, item === people && styles.segmentOn)}
              aria-pressed={item === people}
              onClick={() => onPeople(item)}
            >
              {intl.formatMessage(aiPeopleMessages[item])}
            </button>
          ))}
        </div>
      </div>
    </>
  );
};

export const AiLookControls = TypedMemo(AiLookControlsComponent);
